import { useState, useEffect, useRef } from 'react';
import i18next from 'i18next';
import Select from 'react-select';
import {
	Form,
	Alert,
	Breadcrumb,
	Button,
	Card,
	Tabs,
	Tab,
	Col,
	Container,
	FormControl,
	ListGroup,
	Modal,
	Row,
	Spinner,
} from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
	AccountEntitySearch,
	UpdateOpportunityDTO,
	EditVehicle,
	OpportunityEntity,
	OpportunityField,
} from '../../api/models/AccountEntity';
import { FaLink } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../hooks/useApiClient';
import Restricted from '../../components/Restricted/Restricted';
import AccountSmallPreview from '../../components/AccountSmallPreview/AccountSmallPreview';
import OpportinityDocumentUploaderModal from '../../components/Opportunities/OpportunityDocumentUploaderModal/OpportunityDocumentUploaderModal';
import { Markets, ReactSelectOption } from '../../types';
import {
	ConfirmSellVehicleRequestDTO,
	OptionDTO,
	VehicleStateEnum,
	VehicleEntity,
	TiassistoGetDriveItEasyStatusRequest,
	VehicleUpdateRequestDTO,
	UserDTO,
} from '../../api';
import { OPPORTUNITY_STATES_DATA, horizonPointId } from '../../utils/constants';
import { renderFloatAsStr, strToFloat } from '../../utils';
import { TiassistoVehicleSaveRequestDTO } from '../../api/models/TiassistoModels/TiassistoVehicleSaveRequestDTO';
import {
	DriveItEasyStatusEnum,
	OpportunityStageEnum,
	OpportunityPageTabsEnum,
	RoleEnum,
} from '../../api/models/Enums';
import { useAuth } from '../../hooks/useAuth';
import TiassistoPudList from '../../components/TiAssisto/PudList/TiassistoPudList';
import OpportunityHeader from '../../components/Opportunities/Opportunity/OpportunityHeader';
import OpportunityDetails from '../../components/Opportunities/Opportunity/OpportunityDetails';
import OpportunityVehicle from '../../components/Opportunities/Opportunity/OpportunityVehicle';
import toaster from '../../utils/toaster';
import { Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { dynamicTranslateOpportunityFields } from '../../utils/opportunity';
import { translateSfTypePickvalues } from '../../utils/translations';
import useTiassistoStore from '../../store/TiassistoStore';
import useSalesforceStore from '../../store/SalesforceStore';
import _ from 'lodash';
import { isMarket } from 'src/utils/markets';
// @ts-ignore
import './opportunityPage.scss';
import OpportunityFileManagement from '../../components/Opportunities/OpportunityDocumentsAreas/OpportunityFileManagement';
import { useErrorToast } from 'src/hooks/useErrorToast';
import ToolTip from 'src/components/Tooltip/Tooltip';

const maxNofCopies = 15;

const Opportunity = () => {
	const { id } = useParams<{ id: string }>();
	const location = useLocation();
	const { user, userRole, userReferencePartnerList } = useAuth();

	const from = new URLSearchParams(location.search).get('from');
	const { apiClient, handleApi, handleApiResponse } = useApiClient();
	const [opportunityResponse, setOpportunityResponse] =
		useState<OpportunityEntity | null>(null);
	const [currentState, setCurrentState] = useState<
		(ReactSelectOption & { cssClass: string }) | null
	>(null);
	const [availableStates, setAvailableStates] = useState<
		(ReactSelectOption & { cssClass: string })[]
	>([]);
	const [accountResponse, setAccountResponse] =
		useState<AccountEntitySearch | null>(null);
	const [vehicleResponse, setVehicleResponse] = useState<VehicleEntity | null>(
		null
	);
	const [showStateChangeModal, setShowStateChangeModal] =
		useState<boolean>(false);
	const [showUploadDocsModal, setShowUploadDocsModal] =
		useState<boolean>(false);
	const [showDuplicateModal, setshowDuplicateModal] = useState<boolean>(false);
	const [highlighted, setHighlighted] = useState<boolean>(false);
	const [isLoadingSaveTiassisto, setIsLoadingSaveTiassisto] =
		useState<boolean>(false);
	const [isDriveItEasyIsActive, setIsDriveItEasyActive] =
		useState<boolean>(false);
	const [showVehicleNotAvailableModal, setShowVehicleNotAvailableModal] =
		useState<boolean>(false);
	const [loading, setLoading] = useState(true);
	const [updating, setUpdating] = useState<boolean>(false);
	const [downloadingAttachment, setDownloadingAttachment] = useState<
		string | null
	>(null);
	const [duplicateCopies, setDuplicateCopies] =
		useState<ReactSelectOption | null>(null);
	const [duplicateCopiesRes, setDuplicateCopiesRes] = useState<
		string[] | undefined
	>();
	const [opportunityFields, setOpportunityFields] = useState<
		OpportunityField[]
	>([]);
	const [driveItEasyStatus, setDriveItEasyStatus] =
		useState<DriveItEasyStatusEnum>('' as DriveItEasyStatusEnum);
	const [vehicleId, setVehicleId] = useState<string | null>(null);
	const [opportunityBackofficeData, setOpportunityBackofficeData] =
		useState<any>();
	const selectedOpportunityNewStageRef = useRef<string | undefined>();
	const navigate = useNavigate();
	const [segnalatoreOpportunity, setSegnalatoreOpportunity] = useState<UserDTO | null>(null);

	const queryClient = useQueryClient();
	const { showError } = useErrorToast();
	const {
		opportunityActiveTab,
		setOpportunityActiveTab,
		setOpportunityData,
		setAccountSalesforce,
	} = useSalesforceStore();
	const { dieStatusData, setDieStatusData, setVehicle } = useTiassistoStore();
	const { t } = useTranslation();
	const [opportunityValues, setOpportunityValues] = useState<{
		name: string;
		Tipologia__c: ReactSelectOption | null;
		Canale__c: ReactSelectOption | null;
		Noleggiatore__c: ReactSelectOption | null;
		Offerta_Edison__c: ReactSelectOption | null;
		commissions: string;
		notes: string;
		driveItEasy: boolean;
		driverEmail: string;
		targa: string,
		telaio: string,
		dataFineContrattoDriveItEasy: string,
		provvigioniPassive: string,
		provvigioniSegnalatore: string,
		LeadSource: ReactSelectOption | null;
	}>({
		name: '',
		Tipologia__c: null,
		Canale__c: null,
		Noleggiatore__c: null,
		Offerta_Edison__c: null,
		commissions: '',
		notes: '',
		driveItEasy: false,
		driverEmail: "",
		targa: "",
		telaio: "",
		dataFineContrattoDriveItEasy: "",
		provvigioniPassive: "",
		provvigioniSegnalatore: "",
		LeadSource: null,
	});
	const [loadingOpportunitySalesUser, setLoadingOpportunitySalesUser] = useState(true);
	const [opportunitySalesUser, setOpportunitySalesUser] = useState<UserDTO | null>(null);
	const isOwnerHmpSalesInternal = opportunitySalesUser?.role === RoleEnum.SALES_INTERNAL;
	const isOwnerHmpSalesDealer = opportunitySalesUser?.role === RoleEnum.SALES_DEALER;
	const isSegnalazione = opportunityResponse?.Canale__c?.toLowerCase() === 'segnalatore';
	const isSalesDealer = userRole === RoleEnum.SALES_DEALER;
	const isOpportunityReadOnly = isSalesDealer && isSegnalazione;

	useEffect(() => {
		const segnalatore = opportunityResponse?.Segnalatore_HMP__c;
		if (!segnalatore) return;

		if (segnalatoreOpportunity?.username === segnalatore) return;

		handleApiResponse(apiClient.userController.getRegisterSingleUser(segnalatore))
			.then((res) => setSegnalatoreOpportunity(res))
			.catch((err) => console.error('Failed to fetch opportunity segnalatore ' + segnalatore, err))
	}, [opportunityResponse?.Segnalatore_HMP__c])

	useEffect(() => {
		return () => {
			setOpportunityActiveTab?.(OpportunityPageTabsEnum.DETAILS);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const OpportunityValidationSchema = Yup.object().shape({
		name: Yup.string()
			.required(t('required_field'))
			.transform((value) => `HMP-${value.replace(/^HMP-?/, '')}`),
		commissions: Yup.string().when('Canale__c', {
			is: (value: any) => {
				const canale = _.isObject(value) ? value.value : value;
				return canale?.toLowerCase() === 'segnalatore';
			},
			then: (schema) => schema.notRequired(),
			otherwise: (schema) => Yup.string().required(t('required_field')),
		}),
		Canale__c: Yup.object().required(t('required_field')),
		Noleggiatore__c: Yup.object().required(t('required_field')),
		Offerta_Edison__c: Yup.object().notRequired(),
		Tipologia__c: Yup.object().required(t('required_field')),
		driveItEasy: Yup.boolean(),
		driverEmail: Yup.string()
			.email(t('invalid_email'))
			.when('driveItEasy', {
				is: true,
				then: (schema) =>
					schema.email(t('invalid_email')).required(t('required_field')),
			}),
	});

	const duplicateOpts: ReactSelectOption[] = [...Array(maxNofCopies)].map(
		(el, i) => {
			return { value: (i + 1).toString(), label: (i + 1).toString() };
		}
	);

	const dismissStateChange = () => {
		setShowStateChangeModal(false);
		setCurrentState(
			availableStates.find((el) => el.value === opportunityResponse?.StageName)!
		);
		setCurrentState({
			value: opportunityResponse!.StageName,
			...OPPORTUNITY_STATES_DATA[opportunityResponse!.StageName],
		});
	};

	const {
		mutate: createVehicleUser,
		data,
		isPending: pudListsLoading,
		error: pudListError,
	} = useMutation({
		retry: false,
		mutationFn: async (payload: TiassistoVehicleSaveRequestDTO) => {
			setIsLoadingSaveTiassisto(true);
			const result = await apiClient.tiassistoController.createVehicleUser(
				payload
			);
			window.location.reload();
			return result;
		},
		onSuccess: (data) => {
			toaster.success(t('vehcile_associated_tiassito_success'));
		},
		onError: (error) => {
			console.error('Error creating vehicle user:', error);
		},
		onSettled: () => {
			setIsLoadingSaveTiassisto(false);
		},
	});

	// ENABLE/DISABLE DIE (drive it easy)
	const handleEnableDisableDie = () => {
		if (!opportunityValues?.targa || opportunityValues?.targa.length === 0) {
			return;
		}

		let updateDriveItEasyPayload: any = {};

		if (dieStatusData?.serviceStatus === '1') {
			updateDriveItEasyPayload = {
				licensePlate: opportunityValues.targa,
				status: '2',
				log: {
					operator: user?.username ?? '',
					description: "Disabilitazione del Servizio 'Drive It Easy Gold'",
				},
			};
		}

		if (dieStatusData?.serviceStatus === '2') {
			updateDriveItEasyPayload = {
				licensePlate: opportunityValues.targa,
				status: '1',
				log: {
					operator: user?.username ?? '',
					description: "Abilitazione del Servizio 'Drive It Easy Gold'",
				},
			};
		}

		if (
			dieStatusData?.serviceStatus === '2' ||
			dieStatusData?.serviceStatus === '1'
		) {
			handleApiResponse(
				apiClient.tiassistoController.updateDriveItEasy(
					updateDriveItEasyPayload
				),
				setIsLoadingSaveTiassisto
			)
				.then(() => {
					setIsDriveItEasyActive(false);
					if (currentState?.value === OpportunityStageEnum.closed_won) {
						loadTiassistoStatus(opportunityValues.targa);
					}
				})
				.catch((error) => {
					console.error('error', error);
					toaster.error(t('Error_updating_driveItEasy'));
				});
		}

		if (!dieStatusData?.serviceStatus) {
			const formattedDateEndDieContract = dayjs(
				opportunityValues?.dataFineContrattoDriveItEasy
			).format('DD/MM/YYYY');
			const enableDiePayload: TiassistoVehicleSaveRequestDTO = {
				vehicle: {
					licensePlate: opportunityValues?.targa ?? '',
					brand: vehicleResponse?.dati_veicolo?.marca ?? '',
					model: vehicleResponse?.dati_veicolo?.modello ?? '',
					plan_expiration: formattedDateEndDieContract ?? '',
					horizon_point_id: horizonPointId,
				},
				user: {
					firstName: accountResponse?.FirstName,
					lastName: accountResponse?.LastName,
					email: opportunityValues?.driverEmail,
					phone: accountResponse?.Phone,
					vatNumber: accountResponse?.Partita_IVA__c ?? null,
					fiscalCode: accountResponse?.Codice_Fiscale__c ?? '',
					private_client:
						accountResponse?.RecordType?.Name === 'Azienda' ? 1 : 0,
					ragioneSociale: accountResponse?.Ragione_Sociale__c,
					commercial_email: accountResponse?.Owner?.Email ?? '',
					commercial_firstname: accountResponse?.Owner?.Name ?? '',
				},
				log: {
					operator: user?.username ?? '',
					description: 'Inserimento dati veicolo e utente',
				},
			};
			createVehicleUser(enableDiePayload);
		}
	};

	const dismissDuplicateModal = () => {
		setshowDuplicateModal(false);
		setDuplicateCopies(null);
		setDuplicateCopiesRes(undefined);
	};

	const confirmDuplicate = () => {
		if (!id || !duplicateCopies) return;
		setUpdating(true);
		handleApiResponse(
			apiClient.salesforceOpportunityController.duplicateOpportunity(
				id!,
				parseInt(duplicateCopies?.value)
			),
			setUpdating
		).then((res) => {
			setDuplicateCopiesRes(res.data);
		});
	};

	const loadAccountData = async (accountId: string) => {
		const accountRes = await handleApi(
			apiClient.salesforceAccountController.getAccount(accountId)
		);
		if (!accountRes.data.length) {
			toast.error(i18next.t('account_not_found'));
			return;
		}
		setAccountResponse(accountRes.data[0]);
		setAccountSalesforce(accountRes.data[0]);
	};

	const loadTiassistoStatus = async (licensePlate: string) => {
		setIsLoadingSaveTiassisto(true);
		const driveItEasyStatusRequestPayload: TiassistoGetDriveItEasyStatusRequest =
		{
			licensePlate,
			log: {
				operator: user?.username,
				description: "Recupero dello Stato del Servizio 'Drive It Easy Gold'",
			},
		};
		try {
			const dieStatus = await handleApi(
				apiClient.tiassistoController.getDriveItEasyStatus(
					driveItEasyStatusRequestPayload
				)
			);
			const status =
				dieStatus.message === 'Veicolo non trovato.'
					? DriveItEasyStatusEnum.SOSPESO
					: dieStatus.serviceStatusDescription;
			setDriveItEasyStatus(status);
			setDieStatusData(dieStatus);
		} catch (err) {
			console.error(err);
		} finally {
			setIsLoadingSaveTiassisto(false);
		}
	};

	const loadVehicleData = async (vehicleId: string) => {
		const vehicleRes = await handleApi(
			apiClient.vehicleController.getVehicles1(vehicleId)
		);
		setVehicleResponse(vehicleRes);
		setVehicle(vehicleRes);
		return vehicleRes;
	};

	const changeStateClicked = () => {
		if (
			vehicleResponse &&
			[VehicleStateEnum.VENDUTO, VehicleStateEnum.OSCURATO].includes(
				vehicleResponse.stato_corrente?.type as VehicleStateEnum
			)
		) {
			selectedOpportunityNewStageRef.current = [
				OpportunityStageEnum.closed_won,
				OpportunityStageEnum.credit_score_check,
			].includes(currentState?.value as OpportunityStageEnum)
				? currentState?.value
				: undefined;
			setShowVehicleNotAvailableModal(true);
		} else {
			setShowStateChangeModal(true);
		}
	};

	const getOriginalEditableObj = (): UpdateOpportunityDTO => {
		if (!opportunityResponse) {
			throw new Error('Response is not jet valorized');
		}
		let data = {
			name: opportunityResponse.Name,
			commissions: opportunityResponse.Provvigioni_canale__c,
			channel: opportunityResponse.Canale__c,
			type: opportunityResponse.Tipologia__c,
			dealerName: opportunityResponse.Noleggiatore__c,
			note: opportunityResponse.Messaggio__c || '',
			stageName: opportunityResponse.StageName,
			vehicle: getUpdateVehicleObj(),
			driveItEasy: opportunityResponse.DriveItEasy__c,
			driverEmail: opportunityResponse.DriverEmail__c,
			targa: opportunityResponse.Targa__c,
			telaio: opportunityResponse.Telaio__c,
			offertaEdison: opportunityResponse.Offerta_Edison__c,
			referenceUserId: opportunityResponse.OwnerId,
			backupUsers: opportunityBackofficeData?.backupUsers || [],
			provvigioniSegnalatore: opportunityResponse.Provvigioni_Segnalatore__c,
			provvigioniPassive: opportunityResponse.Provvigioni_passive__c,
			leadSource: opportunityResponse.LeadSource,
		};

		/* SOLO PER HMP ITALIA */
		if (isMarket(Markets.es)) {
			data = _.omit(data, ['offertaEdison']);
		}

		return data;
	};

	const getUpdateVehicleObj = (): EditVehicle => {
		return {
			vehicleId: opportunityResponse?.ID_Vehicle_HMP__c || null,
			customVehicle: opportunityResponse?.ID_Vehicle_HMP__c
				? null
				: {
					brand: opportunityResponse?.Brand__c ?? '',
					model: opportunityResponse?.Modello__c ?? '',
				},
		};
	};

	const computeProvvigioni = (values: any) => {
		const provv = {
			commissions: opportunityResponse?.Provvigioni_canale__c,
			provvigioniSegnalatore: opportunityResponse?.Provvigioni_Segnalatore__c,
			provvigioniPassive: opportunityResponse?.Provvigioni_passive__c,
		};

		const provvPassive = (_.isNil(values.provvigioniPassive) || values.provvigioniPassive?.trim() === "") ? null : strToFloat(values.provvigioniPassive);
		const provvSegnalatore = (_.isNil(values.provvigioniSegnalatore) || values.provvigioniSegnalatore?.trim() === "") ? null : strToFloat(values.provvigioniSegnalatore);
		const provvCanale = strToFloat(values.commissions);

		const isBam = [RoleEnum.BACKOFFICE, RoleEnum.AREA_MANAGER, RoleEnum.MASTER].includes(userRole);

		provv.provvigioniSegnalatore = isSegnalazione ? provvSegnalatore : null;

		// il master, il backoffice e l’a.manager vedono/possono modificare sia Provvigioni Horizon (provvigioni_canale__c) sia Provvigioni Dealer (provvigioni_passive__c)
		if (isBam) {
			provv.commissions = provvCanale;
			provv.provvigioniPassive = provvPassive;
			return provv;
		}

		// il sales interno vede/può modificare “Provvigioni Horizon” (provvigioni_canale__c)
		if (userRole === RoleEnum.SALES_INTERNAL) {
			provv.commissions = provvCanale;
			return provv;
		}

		// il sales dealer vede/ può modificare “Provvigioni Dealer” (provvigioni_passive__c), e Provvigioni Segnalatore quando previsto.
		if (userRole === RoleEnum.SALES_DEALER) {
			provv.provvigioniPassive = provvPassive;
			return provv;
		}

		if (userRole === RoleEnum.SEGNALATORE && isSegnalazione) {
			provv.provvigioniPassive = provvPassive;
			return provv;
		}

		return provv;
	}

	const submitFn = async (values: any, helpers: FormikHelpers<any>) => {
		try {

			let request: UpdateOpportunityDTO = Object.assign(getOriginalEditableObj(), {
				name: values.name,
				commissions: strToFloat(values.commissions),
				channel: values.Canale__c!.value,
				type: values.Tipologia__c!.value,
				dealerName: values.Noleggiatore__c!.value,
				driveItEasy: values.driveItEasy,
				driverEmail: values.driverEmail,
				targa: values.targa,
				telaio: values.telaio,
				nomePartner: values.nomePartner?.value,
				// TODO dataFineContrattoDriveItEasy
				// dataFineContrattoDriveItEasy: values.dataFineContrattoDriveItEasy.length ? values.dataFineContrattoDriveItEasy : null,
				note: values.notes,
				offertaEdison: values.Offerta_Edison__c?.value,
				salesUser: values.salesUser || "",
				backupUsers: values.backupUsers || [],
				leadSource: values.LeadSource?.value,
			},
				computeProvvigioni(values)
			);

			/* SOLO PER HMP ITALIA */
			if (isMarket(Markets.es)) {
				request = _.omit(request, ['offertaEdison']);
			}

			const isClosedWon = request.stageName === OpportunityStageEnum.closed_won;

			if (
				isClosedWon &&
				_.isEmpty(request.offertaEdison) &&
				isMarket(Markets.it)
			) {
				toaster.error(i18next.t('closed_won_edison_field_required'));
				return;
			}

			setUpdating(true);
			await handleApiResponse(
				apiClient.salesforceOpportunityController.editOpportunity(id!, request),
				setUpdating
			);
			queryClient.invalidateQueries({ queryKey: ['opportunityData', id] });

			toast.success(i18next.t('opportunity_updated_success'));

			if (!request?.vehicle?.vehicleId) {
				return;
			}

			if (!vehicleResponse || !vehicleResponse?.id) {
				throw new Error('vehicle is required');
			}

			if (
				opportunityValues?.driverEmail !== values?.driverEmail &&
				opportunityResponse?.StageName === OpportunityStageEnum.closed_won &&
				dieStatusData?.serviceStatus === '1'
			) {
				const formattedDateEndDieContract = dayjs(
					opportunityValues?.dataFineContrattoDriveItEasy
				).format('DD/MM/YYYY');
				const createVehicleUpdated: TiassistoVehicleSaveRequestDTO = {
					vehicle: {
						licensePlate: opportunityValues?.targa ?? '',
						brand: vehicleResponse?.dati_veicolo?.marca ?? '',
						model: vehicleResponse?.dati_veicolo?.modello ?? '',
						plan_expiration: formattedDateEndDieContract ?? '',
						horizon_point_id: horizonPointId,
					},
					user: {
						firstName: accountResponse?.FirstName,
						lastName: accountResponse?.LastName,
						email: values?.driverEmail,
						phone: accountResponse?.Phone,
						vatNumber: accountResponse?.Partita_IVA__c ?? null,
						fiscalCode: accountResponse?.Codice_Fiscale__c ?? '',
						private_client:
							accountResponse?.RecordType?.Name === 'Azienda' ? 1 : 0,
						ragioneSociale: accountResponse?.Ragione_Sociale__c,
						commercial_email: accountResponse?.Owner?.Email ?? '',
						commercial_firstname: accountResponse?.Owner?.Name ?? '',
					},
					log: {
						operator: user?.username ?? '',
						description: 'Inserimento dati veicolo e utente',
					},
				};
				createVehicleUser(createVehicleUpdated);
			}

			const hmpVehicleId = vehicleResponse?.id?.toString();
			if (
				hmpVehicleId &&
				(values.targa !== vehicleResponse?.dettagli_veicolo?.targa ||
					values.telaio !== vehicleResponse?.dettagli_veicolo?.telaio ||
					values.dataFineContrattoDriveItEasy !==
					vehicleResponse?.stato_corrente?.dataFineContrattoDriveItEasy)
			) {
				const updatedStatoCorrente = {
					...vehicleResponse?.stato_corrente,
					dataFineContrattoDriveItEasy:
						values.dataFineContrattoDriveItEasy ||
						vehicleResponse?.stato_corrente?.dataFineContrattoDriveItEasy,
				};

				const updateVehiclePayload: VehicleUpdateRequestDTO = {
					id_bo: vehicleResponse?.dettagli_veicolo?.id_bo,
					city: vehicleResponse?.dettagli_veicolo?.city,
					colore_esterno: vehicleResponse?.dettagli_veicolo?.colore_esterno,
					colore_interno: vehicleResponse?.dettagli_veicolo?.colore_interno,
					data_disp: vehicleResponse?.dettagli_veicolo?.data_disp,
					data_immatricolazione:
						vehicleResponse?.dettagli_veicolo?.data_immatricolazione,
					data_telaio: vehicleResponse?.dettagli_veicolo?.data_telaio,
					giorno_disp: vehicleResponse?.dettagli_veicolo?.giorno_disp,
					note: vehicleResponse?.dettagli_veicolo?.note,
					optionals: vehicleResponse?.optionals,
					promo: vehicleResponse?.dettagli_veicolo?.promo,
					promo_note: vehicleResponse?.dettagli_veicolo?.promo_note,
					settimana_prod: vehicleResponse?.dettagli_veicolo?.settimana_prod,
					targa: values.targa || vehicleResponse?.dettagli_veicolo?.targa,
					telaio: values.telaio || vehicleResponse?.dettagli_veicolo?.telaio,
					document: vehicleResponse?.dettagli_veicolo?.document,
					stato_corrente: updatedStatoCorrente,
					prezzo_listino: vehicleResponse?.dati_veicolo?.prezzo_listino,
					in_evidenza: vehicleResponse?.dettagli_veicolo?.in_evidenza,
					lista_noleggiatori_quotatore:
						vehicleResponse?.lista_noleggiatori_quotatore,
					extra_sconto_perc: vehicleResponse?.dati_veicolo?.extra_sconto_perc,
					codice_costruttore:
						vehicleResponse?.dettagli_veicolo?.codice_costruttore ?? '',
					codice_colore_esterno:
						vehicleResponse?.dettagli_veicolo?.codice_colore_esterno ?? '',
					codice_colore_interno:
						vehicleResponse?.dettagli_veicolo?.codice_colore_interno ?? '',
					dealer: vehicleResponse?.dettagli_veicolo?.dealer ?? '',
					nr_ordine: vehicleResponse?.dettagli_veicolo?.nr_ordine ?? '',
					limited_visibility: vehicleResponse?.dettagli_veicolo?.limited_visibility || [],
				};

				try {
					await handleApiResponse(
						apiClient.vehicleController.putVehicles(
							hmpVehicleId,
							updateVehiclePayload
						)
					);
					queryClient.invalidateQueries({ queryKey: ['activePudList'] });
					queryClient.invalidateQueries({ queryKey: ['opportunityData', id] });

					toast.success(i18next.t('vehicle_updated_success'));
				} catch (error) {
					console.error('Error in updating vehicle in HMP', error);
					toast.error(i18next.t('vehicle_updated_error'));
				}
			}
		} catch (error) {
			showError(error, 'Failed to submit data.');
		} finally {
			setUpdating(false);
		}
	};

	const trackChangeStateTime = () => {
		try {
			localStorage.setItem(`lastChangedStateTime`, Date.now().toString());
		} catch (error) {
			/* ignore */
		}
	};

	const updateOpportunityStage = async (stageName: string) => {
		if (!opportunityResponse) {
			return;
		}

		setUpdating(true);

		const changingStage =
			stageName && opportunityResponse.StageName !== stageName;
		let request: UpdateOpportunityDTO = getOriginalEditableObj();

		const isClosedWon = stageName === OpportunityStageEnum.closed_won;

		if (
			isClosedWon &&
			_.isEmpty(request.offertaEdison) &&
			isMarket(Markets.it)
		) {
			toaster.error(i18next.t('closed_won_edison_field_required'));
			setUpdating(false);
			return;
		}

		let vehicleRes: VehicleEntity | undefined;

		if (opportunityResponse.ID_Vehicle_HMP__c) {
			vehicleRes = await handleApi(
				apiClient.vehicleController.getVehicles1(
					opportunityResponse.ID_Vehicle_HMP__c
				)
			);
		}

		if (changingStage) {
			request.stageName = stageName;
			if (
				vehicleRes &&
				vehicleRes?.stato_corrente?.opportunityId &&
				vehicleRes?.stato_corrente?.opportunityId !== opportunityResponse.Id
			) {
				setShowVehicleNotAvailableModal(true);
				setUpdating(false);
				return;
			}
		}

		try {
			await handleApi(
				apiClient.salesforceOpportunityController.editOpportunity(id!, request)
			);
			queryClient.invalidateQueries({ queryKey: ['opportunityData', id] });
			if (changingStage) trackChangeStateTime();
		} catch (err: any) {
			if (err.body?.messageList?.includes('vehicle_no_longer_available')) {
				setShowStateChangeModal(false);
				setShowVehicleNotAvailableModal(true);
				return;
			} else {
				showError(err, i18next.t('error_editing_opportunity'));
				return;
			}
		}

		if (changingStage) {
			const hasVehicle =
				opportunityResponse.ID_Vehicle_HMP__c || opportunityResponse.Modello__c;
			if (hasVehicle) {
				try {
					if (
						accountResponse &&
						vehicleRes &&
						opportunityResponse.ID_Vehicle_HMP__c
					) {
						const vehicleState = vehicleRes.stato_corrente
							?.type as VehicleStateEnum;
						if (
							[
								OpportunityStageEnum.waiting_sign,
								OpportunityStageEnum.closed_by_customer,
								OpportunityStageEnum.closed_by_credit_score_check,
							].includes(stageName as OpportunityStageEnum) &&
							VehicleStateEnum.OPZIONATO === vehicleState &&
							vehicleRes?.stato_corrente?.opportunityId === id
						) {
							await handleApi(
								apiClient.vehicleActionsController.deleteOption(
									opportunityResponse.ID_Vehicle_HMP__c
								)
							);
						} else if (stageName === OpportunityStageEnum.closed_won) {
							const closeRequest: ConfirmSellVehicleRequestDTO = {
								cliente: accountResponse?.Name,
								opportunityId: id!,
								pratica_credito: id!,
								vehicleId: opportunityResponse.ID_Vehicle_HMP__c,
								noleggiatore: opportunityResponse.Noleggiatore__c || '',
								ragione_sociale:
									accountResponse.Codice_Fiscale__c ||
									accountResponse.Partita_IVA__c ||
									'',
							};
							await handleApi(
								apiClient.vehicleActionsController.postVehiclesActionsConfirmSell(
									closeRequest
								)
							);
						} else if (stageName === OpportunityStageEnum.credit_score_check) {
							const optionRequest: OptionDTO = {
								cliente: accountResponse?.Name,
								opportunityId: id!,
								vehicleId: opportunityResponse.ID_Vehicle_HMP__c,
								ragione_sociale:
									accountResponse.Codice_Fiscale__c ||
									accountResponse.Partita_IVA__c ||
									'',
								noleggiatore: opportunityResponse.Noleggiatore__c || '',
								document: [],
							};
							await handleApi(
								apiClient.vehicleActionsController.postVehiclesActions(
									optionRequest
								)
							);
						}
					}
				} catch (e) {
					console.error(e);
					showError(e, i18next.t('error_occurred_after_status_change'));
					setUpdating(false);
					return;
				}
			} else {
				if (
					![
						OpportunityStageEnum.closed_by_customer,
						OpportunityStageEnum.closed_by_credit_score_check,
					].includes(stageName as OpportunityStageEnum)
				) {
					setShowVehicleNotAvailableModal(true);
					return;
				}
			}
		}

		toast.success(i18next.t('executed_successfully'));
		// loadData();
		navigate(0);
		setUpdating(false);
	};

	const confirmStateChange = async () => {
		selectedOpportunityNewStageRef.current = [
			OpportunityStageEnum.closed_won,
			OpportunityStageEnum.credit_score_check,
		].includes(currentState?.value as OpportunityStageEnum)
			? currentState?.value
			: undefined;

		await updateOpportunityStage(currentState?.value!);
		setShowStateChangeModal(false);
	};

	// useQuery for fetching opportunity data
	const {
		data: opportunityData,
		isLoading: isOpportunityLoading,
		error: opportunityError,
	} = useQuery({
		queryKey: ['opportunityData', id],
		queryFn: async () => {
			if (!id) throw new Error(i18next.t('invalid_or_missing_opportunity_id'));
			const response = await handleApi(
				apiClient.salesforceOpportunityController.getOpportunity(id)
			);
			if (!response.data.length) {
				throw new Error(i18next.t('opportunity_not_found'));
			}
			return response.data[0];
		},
		enabled: !!id, // Only run if id is present
		refetchOnWindowFocus: false,
		retry: false,
	});

	const loadData = async (resetFormFn?: any) => {
		if (!opportunityData) return; // Wait for useQuery data

		setUpdating(true);

		// Fetch opportunity fields
		const opportunityFieldsRes = await handleApi(
			apiClient.salesforceOpportunityController.getOpportunityFields()
		);
		let accTyps = dynamicTranslateOpportunityFields(opportunityFieldsRes);
		accTyps.push({
			label: t('dealer'),
			name: 'nomePartner',
			picklistValues: userReferencePartnerList.map((value) => ({
				active: true,
				label: value,
				value: value,
			})),
		});

		const edisonIdx = accTyps?.findIndex(
			(field) => field?.name === 'Offerta_Edison__c'
		);

		if (![null, undefined, -1].includes(edisonIdx)) {
			const [edisonField] = accTyps.splice(edisonIdx, 1);
			edisonField && isMarket(Markets.it) && accTyps.push(edisonField);
		}

		setOpportunityFields(accTyps);

		const backofficeData = await handleApi(
			apiClient.salesforceOpportunityController.getOpportunityBackoffice(
				opportunityData.Id
			)
		);
		backofficeData && setOpportunityBackofficeData(backofficeData);

		// Set opportunity data from useQuery
		const opportinityRes: OpportunityEntity = opportunityData;
		setOpportunityResponse(opportinityRes);
		setOpportunityData(opportinityRes);

		// Load account data
		await loadAccountData(opportinityRes.AccountId);

		// Load vehicle data if available
		const vehicleId = opportinityRes.ID_Vehicle_HMP__c ?? null;
		setVehicleId(vehicleId);
		let vehicleRes;
		if (vehicleId) {
			vehicleRes = await loadVehicleData(vehicleId);
		}

		// EDIT FORM MODE
		const opportunityValues = {
			name: opportinityRes.Name,
			commissions: opportinityRes.Provvigioni_canale__c
				? renderFloatAsStr(opportinityRes.Provvigioni_canale__c.toString())
				: '0',
			Tipologia__c: {
				label: translateSfTypePickvalues(opportinityRes.Tipologia__c),
				value: opportinityRes.Tipologia__c,
			},
			Canale__c: {
				label: opportinityRes.Canale__c,
				value: opportinityRes.Canale__c,
			},
			Noleggiatore__c: {
				label: opportinityRes.Noleggiatore__c,
				value: opportinityRes.Noleggiatore__c,
			},
			Offerta_Edison__c: opportinityRes.Offerta_Edison__c
				? {
					label: opportinityRes.Offerta_Edison__c,
					value: opportinityRes.Offerta_Edison__c,
				}
				: null,
			notes: opportinityRes.Messaggio__c || '',
			driveItEasy: opportinityRes.DriveItEasy__c,
			driverEmail: opportinityRes.DriverEmail__c || '',
			targa: opportinityRes.Targa__c || vehicleRes?.dettagli_veicolo?.targa || '',
			telaio: opportinityRes.Telaio__c || vehicleRes?.dettagli_veicolo?.telaio || '',
			dataFineContrattoDriveItEasy: vehicleRes?.stato_corrente?.dataFineContrattoDriveItEasy || '',
			nomePartner: { label: opportinityRes.Nome_partner__c, value: opportinityRes.Nome_partner__c },
			salesUser: opportinityRes.Owner_HMP__c || '',
			referenceUserId: opportinityRes?.OwnerId,
			backupUsers: backofficeData?.backupUsers,
			provvigioniPassive: opportinityRes.Provvigioni_passive__c || '0',
			provvigioniSegnalatore: opportinityRes.Provvigioni_Segnalatore__c || '0',
			LeadSource:  opportinityRes.LeadSource ? {
				label: opportinityRes.LeadSource,
				value: opportinityRes.LeadSource,
			} : null,
		};

		setOpportunityValues(opportunityValues);

		opportinityRes.availableStates = opportinityRes.availableStates || [];
		const states = opportinityRes.availableStates?.map((el) => {
			return { value: el, ...OPPORTUNITY_STATES_DATA[el] };
		});

		const currState = {
			value: opportinityRes.StageName,
			cssClass:
				OPPORTUNITY_STATES_DATA[opportinityRes.StageName]?.cssClass ||
				'primary',
			label:
				OPPORTUNITY_STATES_DATA[opportinityRes.StageName]?.label ||
				opportinityRes.StageName,
		};

		setCurrentState(currState);
		setAvailableStates(
			[...states, currState].filter((el) => {
				if (opportinityRes.StageName === OpportunityStageEnum.suspended) {
					return true;
				} else {
					if (el.value === OpportunityStageEnum.suspended) {
						return false;
					}
					if (
						![
							RoleEnum.MASTER,
							RoleEnum.BACKOFFICE,
							RoleEnum.ADMIN,
							RoleEnum.AREA_MANAGER,
						].includes(userRole) &&
						opportinityRes.ID_Vehicle_HMP__c &&
						el.value === OpportunityStageEnum.closed_won
					) {
						return false;
					}
					return true;
				}
			})
		);

		if (resetFormFn) {
			resetFormFn({ values: opportunityValues });
		}

		if (opportinityRes.Targa__c) {
			loadTiassistoStatus(opportinityRes.Targa__c);
		}

		setUpdating(false);
	};

	// Reset opportunity change on page load
	useEffect(() => {
		try {
			const lastStageChangeTime = localStorage.getItem('lastChangedStateTime');

			if (
				lastStageChangeTime &&
				Date.now() - parseInt(lastStageChangeTime, 10) < 5000
			) {
				return;
			}
		} catch (error) {
			/* ignore */
		}

		if (userRole === RoleEnum.BACKOFFICE) {
			handleApi(
				apiClient.salesforceOpportunityController.resetOpportunityAlert(id!)
			);
		}
	}, []);

	useEffect(() => {
		if (opportunityError) {
			toast.error(
				opportunityError.message || i18next.t('error_loading_opportunity')
			);
			setLoading(false);
			return;
		}

		if (opportunityData && !isOpportunityLoading) {
			loadData()
				.catch((err) => {
					toast.error(err.message || i18next.t('error_loading_opportunity'));
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, [opportunityData, isOpportunityLoading, opportunityError]);

	const updateHighlightedFlag = (isHighlighted: boolean) => {
		setHighlighted(isHighlighted);
		handleApi(
			apiClient.salesforceOpportunityController.resetOpportunityAlert(
				id!,
				isHighlighted ? 'New Alert' : undefined
			)
		);
	};

	const canNavigateToAccount = [
		RoleEnum.BACKOFFICE,
		RoleEnum.SALES,
		RoleEnum.SALES_DEALER,
		RoleEnum.SALES_INTERNAL,
		RoleEnum.MASTER,
		RoleEnum.ADMIN,
		RoleEnum.AREA_MANAGER,
	].includes(userRole);

	const renderOpportunityName = (opportunity: OpportunityEntity) => {
		if (!canNavigateToAccount || !accountResponse?.Name) {
			return <span>{opportunity.Name}</span>;
		}

		const accountFragment = `HMP-${accountResponse.Name}`;
		let name = opportunity.Name;

		try {
			name = opportunity.Name?.includes(accountResponse.Name)
				? opportunity.Name?.substring(accountFragment.length)
				: `-${opportunity.Name?.split('--')[1] || opportunity.Name}`;
		} catch (error) {
			/* ignore */
		}

		return (
			<>
				<Link
					id={`account-link-${opportunity.AccountId}`}
					to={`/my-accounts/${opportunity.AccountId}`}
					className="display-6 account-link"
				>
					{accountFragment}
				</Link>
				<ToolTip
					anchorId={`account-link-${opportunity.AccountId}`}
					content={i18next.t('account_link_navigation')}
					className="default"
				/>
				<span>{name}</span>
			</>
		);
	};
	// @ts-ignore
	const isVehicleUnavailable =
		vehicleResponse &&
		[
			VehicleStateEnum.VENDUTO,
			VehicleStateEnum.OSCURATO,
			VehicleStateEnum.OPZIONATO,
		].includes(vehicleResponse.stato_corrente?.type!);

	const doOptionVehicle = async ({ account, opportunity }) => {
		if (!account || !opportunity) return;
		const optionRequest: OptionDTO = {
			cliente: account!.Name,
			opportunityId: opportunity.Id,
			vehicleId: opportunity.ID_Vehicle_HMP__c,
			ragione_sociale:
				account?.Codice_Fiscale__c || account?.Partita_IVA__c || '',
			noleggiatore: opportunity.Noleggiatore__c || '',
			document: [],
		};
		return await handleApiResponse(
			apiClient.vehicleActionsController.postVehiclesActions(optionRequest)
		);
	};

	const handleSalesforceStageChange = async ({
		opportunity,
		vehicle,
		account,
	}) => {
		if (!vehicle || !account) return;
		if (!opportunity?.ID_Vehicle_HMP__c) return;
		if (showVehicleNotAvailableModal) return;

		const vehicleOpportunityId = vehicle?.stato_corrente?.opportunityId;
		const currentOpportunityId = opportunity?.Id;
		const vehicleCurrentState = vehicle.stato_corrente?.type;
		const isCreditScoreCheck =
			opportunity?.StageName === OpportunityStageEnum.credit_score_check;
		const shouldOptionVehicle =
			isCreditScoreCheck &&
			VehicleStateEnum.DISPONIBILE === vehicleCurrentState;
		const shouldChangeVehicle =
			isCreditScoreCheck &&
			isVehicleUnavailable &&
			vehicleOpportunityId !== currentOpportunityId;

		console.debug({
			shouldOptionVehicle,
			shouldChangeVehicle,
			opportunity,
			vehicle,
			isCreditScoreCheck,
			isVehicleUnavailable,
		});

		if (shouldOptionVehicle) {
			await doOptionVehicle({ account, opportunity });
			navigate(0);
			return;
		}

		if (shouldChangeVehicle) {
			selectedOpportunityNewStageRef.current =
				OpportunityStageEnum.credit_score_check;
			setShowVehicleNotAvailableModal(true);
		}
	};

	useEffect(() => {
		handleSalesforceStageChange({
			opportunity: opportunityData,
			vehicle: vehicleResponse,
			account: accountResponse,
		});
	}, [opportunityData, vehicleResponse, accountResponse]);

	useEffect(() => {
		const oppSalesUser = opportunityResponse?.Owner_HMP__c;
		if (!oppSalesUser) {
			setLoadingOpportunitySalesUser(false);
			return;
		}

		if (opportunitySalesUser?.username === oppSalesUser) {
			setLoadingOpportunitySalesUser(false);
			return;
		}

		handleApiResponse(apiClient.userController.getRegisterSingleUser(oppSalesUser))
			.then((res) => setOpportunitySalesUser(res))
			.catch((err) => {
				showError(err, 'Failed to fetch opportunity sales user ' + oppSalesUser)
			})
			.finally(() => setLoadingOpportunitySalesUser(false));

	}, [opportunityResponse?.Owner_HMP__c])

	const onProvvigioneChange = (field: string, value: string, values: any, setFieldValue) => {
		if (!isSegnalazione) return;

		if (_.isNil(segnalatoreOpportunity?.provvigioni_segnalatore)) return;

		const percSegnalatore = parseFloat(segnalatoreOpportunity?.provvigioni_segnalatore || "0");

		if (field === "provvigioniSegnalatore") {
			const provvSegnalatore = parseFloat(value);
			const provvPassive = provvSegnalatore / (percSegnalatore ? percSegnalatore / 100 : 1);
			setFieldValue("provvigioniPassive", isNaN(provvPassive) ? '' : provvPassive.toFixed(2));
			return;
		}

		if (field === "provvigioniPassive") {
			const provvSegnalatore = parseFloat(value) * (percSegnalatore / 100);
			setFieldValue("provvigioniSegnalatore", isNaN(provvSegnalatore) ? '' : provvSegnalatore.toFixed(2));
			return;
		}
	}

	const isSegnalatore = userRole === RoleEnum.SEGNALATORE;

	return (
		<Restricted
			to={[
				RoleEnum.MASTER,
				RoleEnum.BACKOFFICE,
				RoleEnum.SALES,
				RoleEnum.SALES_DEALER,
				RoleEnum.SALES_INTERNAL,
				RoleEnum.ADMIN,
				RoleEnum.AREA_MANAGER,
				RoleEnum.SEGNALATORE,
			]}
		>
			<Container fluid id="opportunity-page">
				<Breadcrumb>
					{from === 'account' ? (
						<>
							<Breadcrumb.Item href={'/my-accounts'}>
								{t('account_list')}
							</Breadcrumb.Item>
							<Breadcrumb.Item
								href={
									'/my-accounts/' + (accountResponse ? accountResponse.Id : '')
								}
							>
								{accountResponse?.Name}
							</Breadcrumb.Item>
							<Breadcrumb.Item active>
								{opportunityResponse?.Name}
							</Breadcrumb.Item>
						</>
					) : null}
				</Breadcrumb>
				{!loading && opportunityResponse && (
					<div className="display-6 mb-1 mt-3">
						{renderOpportunityName(opportunityResponse)}
					</div>
				)}
				<Tabs
					activeKey={opportunityActiveTab}
					onSelect={(k: string | null) => {
						if (k === null) return;
						const selectedTab = k as OpportunityPageTabsEnum;
						setOpportunityActiveTab(selectedTab);
					}}
				>
					<Tab
						eventKey={OpportunityPageTabsEnum.DETAILS}
						title={i18next.t('opportunity_details')}
						className="tab"
						tabClassName="tab"
					>
						{!loading && opportunityResponse && (
							<>
								<Formik
									initialValues={opportunityValues}
									validationSchema={OpportunityValidationSchema}
									enableReinitialize={true}
									onSubmit={submitFn}
								>
									{({
										errors,
										values,
										handleChange,
										handleSubmit,
										setFieldValue,
										dirty,
									}) => {
										return (
											<Form onSubmit={handleSubmit} autoComplete="off">
												<fieldset disabled={isOpportunityReadOnly}>
													<OpportunityHeader
														{...{
															availableStates,
															currentState,
															setCurrentState,
															opportunityResponse,
															updating,
															changeStateClicked,
															setshowDuplicateModal,
															handleEnableDisableDie,
															values,
															errors,
															dirty,
															isLoadingSaveTiassisto,
															driveItEasyStatus,
															setHighlighted: updateHighlightedFlag,
															highlighted,
														}}
													/>
												</fieldset>
												<OpportunityDetails
													{...{
														driveItEasyStatus,
														values,
														errors,
														handleChange,
														opportunityResponse,
														setFieldValue,
														opportunityFields,
														accountResponse,
														opportunityBackofficeData,
														onProvvigioneChange,
														loadingOpportunitySalesUser,
														opportunitySalesUser,
														isOwnerHmpSalesInternal,
														isOwnerHmpSalesDealer,
														isOpportunityReadOnly,
													}}
												/>
												{accountResponse && from !== 'account' && (
													<AccountSmallPreview account={accountResponse} showAccountBtn={!isSegnalatore} />
												)}
												<OpportunityVehicle
													{...{
														values,
														errors,
														handleChange,
														opportunityResponse,
														vehicleResponse,
													}}
												/>
												<fieldset disabled={isOpportunityReadOnly}>
													<Card className="mb-4">
														<Card.Body>
															<FormControl
																as="textarea"
																name="notes"
																onChange={handleChange}
																placeholder={`${i18next.t('add_notes')}...`}
																style={{ height: '200px' }}
																value={values.notes}
															/>
														</Card.Body>
													</Card>
												</fieldset>
											</Form>
										);
									}}
								</Formik>
								<div className="py-2">
									<hr />
								</div>
								{opportunityResponse?.StageName ===
									OpportunityStageEnum.closed_won && (
										<TiassistoPudList
											licensePlate={opportunityValues?.targa || ''}
											driveItEasyStatus={driveItEasyStatus}
										/>
									)}
							</>
						)}
					</Tab>
					<Tab
						eventKey={OpportunityPageTabsEnum.DOCUMENTS}
						title={i18next.t('credit_management')}
						className="tab"
						tabClassName="tab"
					>
						{/* <fieldset disabled={isOpportunityReadOnly}> */}
							<OpportunityFileManagement
								opportunitySalesUser={opportunitySalesUser}
								isVehicleUnavailable={isVehicleUnavailable}
								isOpportunityReadOnly={isOpportunityReadOnly}
								setShowVehicleNotAvailableModal={(bool, newOpportunityStage) => {
									selectedOpportunityNewStageRef.current =
										OpportunityStageEnum.credit_score_check ===
											newOpportunityStage
											? OpportunityStageEnum.credit_score_check
											: undefined;
									setShowVehicleNotAvailableModal(bool);
								}}
							/>
						{/* </fieldset> */}
					</Tab>
				</Tabs>
				<Modal
					show={showDuplicateModal}
					onExited={() => dismissDuplicateModal()}
				>
					<Modal.Header>
						<Modal.Title>{t('duplicate_opportunity')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{duplicateCopiesRes ? (
							<div>
								<ListGroup>
									{duplicateCopiesRes.map((el, i) => {
										return (
											<ListGroup.Item key={el}>
												<Row className="d-flex justify-content-between">
													<Col>Copia n.{i + 1}</Col>
													<Col className="d-flex justify-content-end">
														<Button
															target="_blank"
															href={`/opportunities/${el}?from=account`}
														>
															<FaLink /> {t('visualize')}
														</Button>
													</Col>
												</Row>
											</ListGroup.Item>
										);
									})}
								</ListGroup>
							</div>
						) : (
							<div>
								<span>{t('enter_number_of_copies_to_make')}</span>
								<Row className="mt-3">
									<Col md={6}>
										<Select
											menuPosition="fixed"
											placeholder={i18next.t('select_couples')}
											options={duplicateOpts}
											value={duplicateCopies}
											onChange={(opt: any) => {
												setDuplicateCopies(opt);
											}}
										/>
									</Col>
								</Row>
							</div>
						)}
					</Modal.Body>
					<Modal.Footer>
						{duplicateCopiesRes ? (
							<Button onClick={() => setshowDuplicateModal(false)}>
								{t('close')}
							</Button>
						) : (
							<>
								<Button
									variant="link"
									onClick={() => setshowDuplicateModal(false)}
									disabled={updating}
								>
									{t('cancel')}
								</Button>
								<Button onClick={confirmDuplicate} disabled={updating}>
									{updating ? (
										<Spinner animation="border" size="sm" />
									) : (
										'Conferma'
									)}
								</Button>
							</>
						)}
					</Modal.Footer>
				</Modal>
				<OpportinityDocumentUploaderModal
					show={showUploadDocsModal}
					opportunity={opportunityResponse ?? undefined}
					onHide={() => {
						setShowUploadDocsModal(false);
					}}
					onSuccess={() => {
						setShowUploadDocsModal(false);
						loadData();
					}}
				/>

				<Modal show={showStateChangeModal} onExit={() => dismissStateChange()}>
					<Modal.Header>
						<Modal.Title>
							{t('change_opportunity_status_confirm_request')}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{t('proceeding_opportunity_will_be_set_to_state').replaceAll(
							'<br />',
							' '
						)}{' '}
						"<b>{currentState?.label}</b>"
						{currentState?.value === OpportunityStageEnum.closed_won && (
							<span>
								{t('and_vehicle_in_state_sold')} "<b>{t('sold')}</b>"
							</span>
						)}
						{[
							OpportunityStageEnum.closed_by_customer,
							OpportunityStageEnum.closed_by_credit_score_check,
						].includes(currentState?.value as OpportunityStageEnum) && (
								<span>
									{t('and_vehicle_in_state_sold')} "<b>{t('available')}</b>"
								</span>
							)}
						{currentState?.value ===
							OpportunityStageEnum.credit_score_check && (
								<span>
									{t('and_vehicle_in_state_sold')} "<b>{t('optioned')}</b>"
								</span>
							)}
					</Modal.Body>
					<Modal.Footer>
						<Button
							variant="link"
							onClick={() => setShowStateChangeModal(false)}
							disabled={updating}
						>
							{t('cancel')}
						</Button>
						<Button onClick={confirmStateChange} disabled={updating}>
							{updating ? (
								<Spinner animation="border" size="sm" />
							) : (
								i18next.t('confirm')
							)}
						</Button>
					</Modal.Footer>
				</Modal>
				<Modal
					show={showVehicleNotAvailableModal}
					onHide={() => {
						dismissStateChange();
						setShowVehicleNotAvailableModal(false);
					}}
				>
					<Modal.Header>
						<Modal.Title>{t('vehicle_available_no_more')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Alert>{t('warning_selected_vehicle_not_available')}</Alert>
					</Modal.Body>
					<Modal.Footer>
						<Button
							variant="link"
							onClick={() => setShowVehicleNotAvailableModal(false)}
						>
							{t('cancel')}
						</Button>
						<Button
							href={`/opportunities/${id}/edit?action=update_vehicle&from=opportunity&opportunityNewStage=${selectedOpportunityNewStageRef.current}`}
						>
							{t('change_vehicle')}
						</Button>
					</Modal.Footer>
				</Modal>
			</Container>
		</Restricted>
	);
};

export default Opportunity;
